<template>
  <div class="BookRead" v-if="isloadDom">
    <!-- 已购目录 -->
    <div
      class="chaptersBox"
      :style="isshowPurchased ? 'background: #353535' : ''"
    >
      <!-- 左边 工具栏 -->
      <div class="leftToolBar">
        <!-- 页码+标题 -->
        <div class="pageTitle">
          <p>
            <span>{{ readingPage }}</span
            ><span>{{ "/" + infoObj.pageCount }}</span>
          </p>
          <p>{{ infoObj.informationContentTitle }}</p>
        </div>
        <!-- 章节 -->
        <div class="chapterControl" @click="OpenPurchased"></div>
      </div>
      <div
        :class="
          isshowPurchased
            ? 'PurchasedWrapper PurchasedShow'
            : 'PurchasedWrapper PurchasedHide'
        "
      >
        <PurchasedChapters
          :catalogList="catalogList"
          :readingPhapterId="chapterId"
          :InformationId="InformationId"
        />
      </div>
    </div>
    <!-- 内容 -->
    <div
      ref="MycontWrap"
      :class="isscale ? 'smallContSty contWrap' : 'contWrap'"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div
        ref="myContent"
        :class="
          scaleNamIndex <= 2 ? 'smallContSty imgWrap' : 'imgWrap transformSty'
        "
      >
        <img
          :src="ReadUrl"
          :class="
            courseSty == 0 ? 'courseUp normalImg' : 'courseDown normalImg'
          "
          @load="ImgSuccess"
          @mousemove="MouseOverFn($event)"
          @click="ChangeImgFn"
        />
      </div>
    </div>
    <!-- 右边 工具栏 -->
    <div class="rightToolBar">
      <div class="packup-toolbar" v-show="switchToolbar">
        <!-- 上下页切换 -->
        <div class="updownBtnWrap">
          <span @click="TurnPageUp">上页</span>
          <span @click="TurnPageDown">下页</span>
        </div>
        <!-- 返回书本详情 -->
        <div class="homeBox">
          <router-link
            :to="{
              path: '/bookDetail',
              query: { InformationId: InformationId }
            }"
            title="点击这里可以返回此书详情"
          >
            <span>返回</span>
            <span>详情</span>
          </router-link>
        </div>
        <!-- 缩放 -->
        <div class="scaleWrap">
          <span
            :class="scaleNamIndex == 0 ? 'ScaleDisabled' : 'ScaleLight'"
            @click="ReducePage"
          ></span>
          <span>{{ scaleNamArr[scaleNamIndex] + "%" }}</span>
          <span
            :class="scaleNamIndex == 4 ? 'ScaleDisabled' : 'ScaleLight'"
            @click="EnlargePage"
          ></span>
          <span
            :class="scaleMode ? 'fitsize' : 'locking'"
            title="点击这里可以锁定缩放模式"
            @click="ChangeReadMode"
          ></span>
        </div>
        <!-- 收起 -->
        <span class="switch-toolbar packup-tb" @click="SwitchBarFn"></span>
      </div>
      <!-- 收起 -->
      <span
        class="switch-toolbar open-tb"
        @click="SwitchBarFn"
        v-show="!switchToolbar"
      ></span>
      <!-- 全屏 -->
      <div
        class="allScreen FullScreen_open"
        v-if="isFullScreen"
        @click="OpenFullScreenFn"
      ></div>
      <div
        class="allScreen FullScreen_exit"
        v-else
        @click="ExitFullscreenFn"
      ></div>
    </div>
    <!-- 引导提示 -->
    <div class="tipWrap" v-if="showGuideTip" @click="closeGuideTip">
      <div class="closeChapterBox">
        <p></p>
        <p>
          这里可以关闭目录<span></span
          ><img src="../../assets/img/chapter_close.svg" />
        </p>
      </div>
      <div class="mouseTipBox"><img src="../../assets/img/mouseTip.png" /></div>
      <div class="lockingBox">
        <p>
          点击这里可以锁定缩放比例<span></span
          ><img src="../../assets/img/scaleTip.svg" />
        </p>
        <p></p>
      </div>
    </div>
  </div>
  <!-- mobile 布局 -->
  <div class="BookRead" v-else>
    <!-- 面包屑 -->
    <div class="BreadcrumbWrap" v-show="isshowBreadcrumb">
      <div class="titleReturn">
        <div class="return" @click="BookReadReturn"></div>
        <h3>{{ infoObj.informationContentTitle }}</h3>
      </div>
      <!-- 用户头像 -->
      <a
        href="https://m.tunnelling.cn/Manager/MemberIndex.aspx"
        class="userWrap"
        v-if="isshowHead"
        ><img :src="userImg" alt=""
      /></a>
    </div>
    <!-- 内容 -->
    <div
      class="contWrap"
      :style="'height:' + windowHeight + 'px'"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <v-touch
        @swipeleft="LeftRightFn(0)"
        @swiperight="LeftRightFn(1)"
        @swipeup="UpDownFn(0)"
        @swipedown="UpDownFn(1)"
        class="wrapper"
      >
        <div id="map_img" @click="CloseTool">
          <img :src="ReadUrl" @load="ImgSuccess" />
        </div>
      </v-touch>
    </div>
    <!-- 页码+标题 -->
    <div class="pageTitle">
      <p>
        {{ readingPage }}<span>{{ "/" + infoObj.pageCount }}</span>
      </p>
      <p>{{ infoObj.informationContentTitle }}</p>
    </div>
    <!-- 工具栏-展开 -->
    <div class="toolbarOpen" v-show="isshowToolbar">
      <!-- 已购买章节 -->
      <div class="buyChapter" @click="OpenPurchased">
        <img src="../../assets/img/buyChapter_icon.svg" alt="" /><span
          >章节列表</span
        >
      </div>
      <!-- 阅读模式 -->
      <div class="ReadingMode">
        <div class="ReadText" @click="ShowReadMode">
          <img src="../../assets/img/readMode_icon.svg" alt="" /><span
            >阅读模式</span
          >
        </div>
        <div class="mode" v-show="isshowReadmode">
          <span :class="readMode ? '' : 'modeLight'" @click="CloseReadModeFn(1)"
            >上下滑动</span
          >
          <span :class="readMode ? 'modeLight' : ''" @click="CloseReadModeFn(0)"
            >左右翻页</span
          >
        </div>
      </div>
    </div>
    <!-- mobile 上一节 下一节 -->
    <div class="TurnPage_mobile" v-show="isshowTurnPage">
      <span
        class="pageUp"
        :class="CurrentChapter == 1 ? 'pageDisabled' : 'pageLight'"
        @click="LastSection"
        >上一节</span
      >
      <div class="block">
        <el-slider
          v-model="CurrentChapter"
          @change="DragChapter"
          :max="infoObj.purchasedCount"
        ></el-slider>
      </div>
      <span
        class="pageDown"
        :class="
          CurrentChapter == infoObj.purchasedCount
            ? 'pageDisabled'
            : 'pageLight'
        "
        @click="NextSection"
        >下一节</span
      >
    </div>
    <!-- 已购目录 -->
    <div v-show="isshowPurchased">
      <PurchasedChapters
        :catalogList="catalogList"
        :readingPhapterId="chapterId"
        :InformationId="InformationId"
        :isPC="isloadDom"
      />
    </div>
    <!-- 引导提示 -->
    <div class="tipWrap" v-if="showGuideTip">
      <div class="mouseTipBox"></div>
      <div class="closeChapterBox" @click="closeGuideTip"></div>
      <div class="lockingBox"></div>
    </div>
  </div>
</template>

<script>
import common from "../../assets/js/common.js";
import PurchasedChapters from "../../components/PurchasedChapters.vue";
import PinchZoom from "../../assets/js/pinchzoom.js";
export default {
  name: "BookRead",
  data() {
    return {
      isshowToolbar: true, // 是否展开工具栏
      isshowBreadcrumb: true, // 是否显示导航栏
      isshowTurnPage: true, // 移动端-是否显示上一节下一节
      isshowReadmode: false, // 是否显示阅读模式
      readMode: false, // 阅读模式or是否显示翻页按钮 true：左右翻页 false：上下滚动
      scaleNamArr: [50, 75, 100, 150, 200], // 缩放数数组
      scaleNamIndex: 2, // 页面缩放数
      pcContDom: null, // pc内容dom
      CurrentChapter: 1, // 当前节
      isshowPurchased: true, // 是否显示已购章节
      isloadDom: true, // true:pc false:mobile
      InformationId: undefined, // 情报id
      chapterId: undefined, // 章节id
      readingPage: 1, // 正在读的页数
      ReadUrl: "", // 正在读的url
      userImg: "", // 用户头像
      isshowHead: true, // 是否显示用户头像
      catalogList: [], // 已购章节
      isBlank: false, // 已购目录是否显示空白页
      purchasedArr: [], // 已购目录--不分章节结构
      forNum: 0, // 节id的位置(已购目录第几节)
      allChapterNum: 0, // 每章and节index
      searchTitle: "", // 搜索词
      isscale: false, // 是否缩放
      isFullScreen: true, // 是否全屏
      scaleMode: false, // 缩放模式
      showGuideTip: true, // 是否显示引导提示
      infoObj: {}, // 当前章 信息
      loading: false, // 是否加载完成
      courseSty: 0, // 鼠标样式 -1:normal 0:up 1:down
      windowHeight: window.innerHeight,
      switchToolbar: true, // pc展开收起 右边工具栏
      buyup: false
    };
  },
  created() {
    // 获取情报id
    this.InformationId = this.$route.query.InformationId - 0;
    // 获取章节id
    this.chapterId = this.$route.query.id - 0;
    // 获取已购信息
    this.GetPurchasedInfo("first");
  },
  mounted() {
    // 判断加载哪个dom
    let wid = window.innerWidth;
    if (wid >= 320 && wid <= 1024) {
      this.isloadDom = false;
      this.isshowPurchased = false;
      this.$nextTick(() => {
        let myElement = document.getElementById("map_img");
        let pz = new PinchZoom(myElement, {
          minZoom: 0.5,
          maxZoom: 12,
          zoomFactor: 1
        });
      });
    } else {
      this.isloadDom = true;
      this.pcContDom = this.$refs.MycontWrap;
    }
    // 判断是否已显示过引导
    if (localStorage.getItem("isFirstIntoK") == 11) {
      this.showGuideTip = false;
    }
    // 获取用户信息
    this.JugeIsLogin();
    // 获取已购章节目录
    this.GetPurchasedChapters();
    // 搜索已购
    this.SearchPuchasedFn();
    // 从已购节里阅读
    this.ReadPuchasedFn();
  },
  methods: {
    // pc 右边工具栏的展开收起
    SwitchBarFn() {
      this.switchToolbar = !this.switchToolbar;
    },
    // 点击图片  切换
    ChangeImgFn() {
      if (this.courseSty == 0) {
        this.TurnPageUp();
      } else {
        this.TurnPageDown();
      }
    },
    // 鼠标在图片上移动样式
    MouseOverFn(e) {
      if (e.clientY > this.windowHeight / 2) {
        this.courseSty = 1;
      } else {
        this.courseSty = 0;
      }
    },
    // 图片加载成功
    ImgSuccess() {
      this.loading = false;
    },
    // 获取已购节的信息
    GetPurchasedInfo(type) {
      this.$fetch(
        "/api/information/" +
          this.$route.query.InformationId +
          "/informationContent/purchasedInfo?informationContentId=" +
          this.chapterId
      )
        .then(res => {
          console.log("GetPurchasedInfo", type);
          this.infoObj = res.data;
          // 上一页 需加载上一节内容时执行的(一节中的最后一页)
          if (type == "pageUp") {
            this.readingPage = this.infoObj.pageCount;
            if (
              this.infoObj.pageCount === 1 &&
              this.infoObj.tryReadingPages === 1
            ) {
              this.ReadUrl =
                Const_Api_Root +
                "/api/TryReading/" +
                this.chapterId +
                "?pageIndex=1";
            } else {
              this.ReadUrl =
                Const_Api_Root +
                "/api/images/" +
                this.chapterId +
                "?pageIndex=" +
                this.readingPage; // 内容
            }
          }
          // 上一页 上一节如果有在同一页内容时执行
          if (type == "previous") {
            this.readingPage = this.infoObj.pageCount;
            if (this.infoObj.pageCount === 1) {
              this.TurnPageUp();
            } else if (this.infoObj.pageCount === 2) {
              this.readingPage = 1;
              this.ReadUrl =
                Const_Api_Root +
                "/api/TryReading/" +
                this.chapterId +
                "?pageIndex=1"; // 内容
            } else {
              this.readingPage -= 1;
              this.ReadUrl =
                Const_Api_Root +
                "/api/images/" +
                this.chapterId +
                "?pageIndex=" +
                this.readingPage; // 内容
            }
          }
          // 下一页 需加载下一节内容时，如果下一节内容pageCount为1时，自动再加载下一节内容
          if (type == "next" && this.infoObj.pageCount === 1) {
            this.readingPage = 1;
            this.TurnPageDown();
          }
          // 正常加载(只有下一节 or 上一节时才会执行)
          if (
            this.infoObj.tryReadingPages === 0 ||
            this.readingPage > this.infoObj.tryReadingPages
          ) {
            this.ReadUrl =
              Const_Api_Root +
              "/api/images/" +
              this.chapterId +
              "?pageIndex=" +
              this.readingPage;
          } else {
            this.ReadUrl =
              Const_Api_Root +
              "/api/TryReading/" +
              this.chapterId +
              "?pageIndex=" +
              this.readingPage;
          }
          // 从首页进来时不执行后续代码
          if (type == "first") return;
          this.GetLight();
          // 图片大小
          this.ImgFn();
        })
        .then(() => {
          if (type != "first") return;
          document.title = this.infoObj.informationTitle + "-知识服务平台";
          this.updateWXShareInfo();
        })
        .catch(err => {
          throw err;
        });
    },
    // 搜索已购
    SearchPuchasedFn() {
      common.$on("SearchPuchased", title => {
        this.searchTitle = title;
        this.GetPurchasedChapters("search");
      });
    },
    // 从已购章节里阅读
    ReadPuchasedFn() {
      common.$on("ReadPuchased", (id, ind) => {
        // 如果点击当前章节阅读按钮 正是当前所读的章节de第一页 return
        if (this.chapterId === id && this.readingPage === 1) return;

        this.chapterId = id;
        this.readingPage = 1;
        this.loading = true;

        if (ind) {
          this.CurrentChapter = ind;
          common.$emit(
            "ScrollTopVal",
            this.infoObj.subChapterCount,
            this.purchasedArr[this.CurrentChapter - 1].arrIndex
          );
          this.loading = true;
        } else {
          this.GetProgress();
        }
        this.GetPurchasedInfo();
        // mobile-上一节 下一节的显示
        if (!this.isloadDom) {
          this.isshowTurnPage = this.isshowToolbar;
          this.isshowPurchased = false;
        }
      });
    },
    // 搜索后的循环
    GetProgress() {
      for (let i = 0; i < this.purchasedArr.length; i++) {
        if (this.chapterId == this.purchasedArr[i].id) {
          this.CurrentChapter = i + 1;
          break;
        }
      }
    },
    // 获取已购章节
    GetPurchasedChapters(type) {
      this.$fetch(
        "/api/information/" +
          this.InformationId +
          "/informationContent/all?Title=" +
          this.searchTitle
      )
        .then(res => {
          this.catalogList = res.data;
          this.forNum = 0;
          this.allChapterNum = 0;
          if (res.data.length == 0) {
            this.isBlank = true;
          } else {
            this.isBlank = false;
          }
          common.$emit("IsShowBlank", this.isBlank);
          if (type) return;
          // 判断本书章节是否已全部购买
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].purchased) {
              this.buyup = false;
              break;
            } else {
              this.buyup = true;
            }
          }

          this.ForEachFn(res.data);
          this.GetLight();
        })
        .catch(err => {
          throw err;
        });
    },
    // 循环已购目录 判断是已购的第几节
    ForEachFn(items) {
      items.forEach((item, index) => {
        if (item.children == null || item.children.length == 0) {
          this.allChapterNum++;
          this.$set(item, "noNextPurchasedTip", false);
          if (item.purchased && item.pageCount > 0) {
            this.forNum++;
            item.index = this.forNum;
            item.arrIndex = this.allChapterNum;
            this.purchasedArr.push(item);
          }
          // 判断当前item是否购买了，未购买就在上一节阅读里把noNextPurchasedTip字段变为true，代表需要提示；
          // purchasedArr.pageCount判断: 1.防止length-1(报错已加入过已购买的章节);2.证明该item不是章节
          if (
            !item.purchased &&
            item.pageCount > 0 &&
            this.purchasedArr.length
          ) {
            this.purchasedArr[
              this.purchasedArr.length - 1
            ].noNextPurchasedTip = true;
          }
        }
        if (this.chapterId == item.id) {
          this.CurrentChapter = this.forNum;
          common.$emit(
            "ScrollTopVal",
            this.infoObj.subChapterCount,
            this.purchasedArr[this.CurrentChapter - 1].arrIndex
          );
        }
        if (item.children) {
          this.ForEachFn(item.children);
        }
      });
    },
    // 滑动 跳到对应的节
    DragChapter() {
      // 判断用户是否登录
      this.JugeIsLogin();
      if (!this.isshowHead) return;
      if (this.CurrentChapter == 0) {
        this.CurrentChapter = 1;
      }
      // 滚动条滑到页首
      if (this.isloadDom) {
        this.pcContDom.scrollTop = 0;
      }
      // 加载上一节内容
      this.chapterId = this.purchasedArr[this.CurrentChapter - 1].id;
      this.readingPage = 1;
      this.GetPurchasedInfo();
    },
    // 上一节
    LastSection() {
      if (this.CurrentChapter == 1) return;
      // 判断用户是否登录
      this.JugeIsLogin();
      if (!this.isshowHead) return;
      // 滚动条滑到页首
      if (this.isloadDom) {
        this.pcContDom.scrollTop = 0;
      }
      // 加载上一节内容
      this.CurrentChapter--;
      this.chapterId = this.purchasedArr[this.CurrentChapter - 1].id;
      this.readingPage = 1;
      this.GetPurchasedInfo();
    },
    // 下一节
    NextSection() {
      if (this.CurrentChapter == this.infoObj.purchasedCount) return;
      // 判断用户是否登录
      this.JugeIsLogin();
      if (!this.isshowHead) return;
      // 滚动条滑到页首
      if (this.isloadDom) {
        this.pcContDom.scrollTop = 0;
      }
      // 加载下一节内容
      this.CurrentChapter++;
      this.chapterId = this.purchasedArr[this.CurrentChapter - 1].id;
      this.readingPage = 1;
      this.GetPurchasedInfo();
    },
    // 上一页
    TurnPageUp() {
      // 一节试读的总页数
      let tryReadPage = this.infoObj.tryReadingPages;
      // 当正在读的是第一页且是第一节时，返回
      if (this.readingPage == 1 && this.CurrentChapter == 1) return;
      this.loading = true;
      // 判断用户是否登录
      this.JugeIsLogin();
      if (!this.isshowHead) return;
      // 滚动条滑到页首
      if (this.isloadDom) {
        this.pcContDom.scrollTop = 0;
      }
      // 当正在读的是第一页，加载上一节
      let nowPreviousNum = this.purchasedArr[this.CurrentChapter - 1].previous;
      // console.log(nowPreviousNum,this.readingPage,this.CurrentChapter,this.pageCount);
      if (this.readingPage == 1) {
        if (nowPreviousNum === 0) {
          this.CurrentChapter--;
          common.$emit(
            "ScrollTopVal",
            this.infoObj.subChapterCount,
            this.purchasedArr[this.CurrentChapter - 1].arrIndex
          );
          this.chapterId = this.purchasedArr[this.CurrentChapter - 1].id; // 节id
          this.GetPurchasedInfo("pageUp"); // 获取当前节信息
          return;
        } else if (nowPreviousNum === 1) {
          this.CurrentChapter--;
        } else {
          this.CurrentChapter -= nowPreviousNum;
        }
        common.$emit(
          "ScrollTopVal",
          this.infoObj.subChapterCount,
          this.purchasedArr[this.CurrentChapter - 1].arrIndex
        );
        this.chapterId = this.purchasedArr[this.CurrentChapter - 1].id;
        this.GetPurchasedInfo("previous"); // 获取当前节信息
        return;
      }
      // 当试读页为0时
      if (tryReadPage == 0) {
        this.readingPage--;
        this.ReadUrl =
          Const_Api_Root +
          "/api/images/" +
          this.chapterId +
          "?pageIndex=" +
          this.readingPage;
        this.ImgFn();
        return;
      }
      // 当正在读的是试读内容和当正在读的是上一页是试读内容时，加载试读链接；否则就加载试读以外内容的链接
      if (
        this.readingPage <= tryReadPage ||
        this.readingPage - 1 == tryReadPage
      ) {
        this.readingPage--;
        this.ReadUrl =
          Const_Api_Root +
          "/api/TryReading/" +
          this.chapterId +
          "?pageIndex=" +
          this.readingPage;
      } else {
        this.readingPage--;
        this.ReadUrl =
          Const_Api_Root +
          "/api/images/" +
          this.chapterId +
          "?pageIndex=" +
          this.readingPage;
      }
      this.GetLight();
      this.ImgFn();
    },
    // 下一页
    TurnPageDown() {
      // 一节试读的总页数
      let tryReadPage = this.infoObj.tryReadingPages;
      // 当正在读的是最后一页且是最后一节时，返回
      if (
        this.buyup &&
        this.readingPage == this.infoObj.pageCount &&
        this.CurrentChapter == this.infoObj.purchasedCount
      ) {
        this.$message("已经是最后一页了。");
        return;
      } else if (
        this.readingPage == this.infoObj.pageCount &&
        this.CurrentChapter == this.infoObj.purchasedCount
      ) {
        this.$message("已经是购买内容的最后一页了，欢迎购买后续章节内容。");
        return;
      } else {
        this.loading = true;
      }
      // 判断用户是否登录
      this.JugeIsLogin();
      if (!this.isshowHead) return;
      // 滚动条滑到页首
      if (this.isloadDom) {
        this.pcContDom.scrollTop = 0;
      }
      // 当正在读的是最后一页且不是最后一节时，加载下一节
      let nowNextNum = this.purchasedArr[this.CurrentChapter - 1].next;
      if (this.readingPage == this.infoObj.pageCount) {
        // 下一章节未购买提示
        if (this.purchasedArr[this.CurrentChapter - 1].noNextPurchasedTip) {
          this.$alert(
            "下一章节未购买，为您直接跳至已购买的后续章节。",
            "提示",
            {
              confirmButtonText: "确定",
              callback: action => {}
            }
          );
        }
        if (nowNextNum === 0) {
          this.CurrentChapter++;
          common.$emit(
            "ScrollTopVal",
            this.infoObj.subChapterCount,
            this.purchasedArr[this.CurrentChapter - 1].arrIndex
          );
          this.readingPage = 1;
          this.chapterId = this.purchasedArr[this.CurrentChapter - 1].id; // 节id
          this.GetPurchasedInfo(); // 获取当前节信息
          return;
        } else if (nowNextNum === 1) {
          this.CurrentChapter++;
        } else {
          this.CurrentChapter += nowNextNum;
        }
        common.$emit(
          "ScrollTopVal",
          this.infoObj.subChapterCount,
          this.purchasedArr[this.CurrentChapter - 1].arrIndex
        );
        this.readingPage = 2;
        this.chapterId = this.purchasedArr[this.CurrentChapter - 1].id; // 节id
        this.GetPurchasedInfo("next"); // 获取当前节信息
        return;
      }
      // 当正在读的是试读内容和当正在读的是下一页是试读内容时，加载试读链接；否则就加载试读以外内容的链接
      if (this.readingPage < tryReadPage) {
        this.readingPage++;
        this.ReadUrl =
          Const_Api_Root +
          "/api/TryReading/" +
          this.chapterId +
          "?pageIndex=" +
          this.readingPage;
      } else {
        this.readingPage++;
        this.ReadUrl =
          Const_Api_Root +
          "/api/images/" +
          this.chapterId +
          "?pageIndex=" +
          this.readingPage;
      }
      this.GetLight();
      this.ImgFn();
    },
    // 图片缩放
    ImgFn() {
      if (!this.isloadDom) return;

      if (this.scaleMode) {
        this.isscale = false;
        this.scaleNamIndex = 2;
        this.$refs.myContent.style.width = "100%";
        this.$refs.myContent.firstElementChild.style.transform =
          "scale(" + this.scaleNamArr[this.scaleNamIndex] / 100 + ")";
      } else {
        setTimeout(() => {
          this.$refs.myContent.style.width = "100%";
          let screenWid = document.body.clientWidth;
          let imgWid = this.$refs.myContent.firstElementChild.offsetWidth;
          let wid = imgWid * (this.scaleNamArr[this.scaleNamIndex] / 100);
          if (screenWid < imgWid) {
            this.isscale = false;
          } else {
            this.isscale = true;
          }
          this.$refs.myContent.style.width = wid + "px";
        }, 300);
      }
    },
    // 判断是否已登录
    JugeIsLogin() {
      this.$fetch("/Login")
        .then(res => {
          if (res.data.accessAllowed === false) {
            this.isshowHead = false;
            this.$alert("未登录状态下无法访问，可能是登录已超时。", "提示", {
              confirmButtonText: "确定",
              showClose: false,
              callback: action => {
                this.$router.push({
                  path: "/bookDetail",
                  query: {
                    InformationId: this.InformationId
                  }
                });
              }
            });
            return;
          }
          this.userImg = res.data.imagePath;
        })
        .catch(err => {
          throw err;
        });
    },
    // mobile-滑动操作
    // 上一页 or 下一页
    LeftRightFn(num) {
      if (!this.readMode) return;
      if (num === 0) {
        this.TurnPageDown();
      } else {
        this.TurnPageUp();
      }
    },
    UpDownFn(num) {
      if (this.readMode) return;
      if (num === 0) {
        this.TurnPageDown();
      } else {
        this.TurnPageUp();
      }
    },
    // 工具栏展开与收起
    OpenToolbar() {
      this.isshowToolbar = !this.isshowToolbar;
      this.isshowBreadcrumb = true;
    },
    // 收起页面上的功能键
    CloseTool() {
      this.isshowToolbar = !this.isshowToolbar;
      this.isshowTurnPage = this.isshowToolbar;
      this.isshowReadmode = false;
      this.isshowBreadcrumb = !this.isshowBreadcrumb;
      this.isshowPurchased = false;
    },
    // 显示阅读模式
    ShowReadMode() {
      this.isshowReadmode = !this.isshowReadmode;
      this.isshowPurchased = false;
      // mobile 关闭上一节-下一节的显示
      this.isshowTurnPage = !this.isshowTurnPage;
    },
    // 缩放模式选择
    ChangeReadMode() {
      this.scaleMode = !this.scaleMode;
    },
    // 全屏预览
    FullScreenFn() {
      this.isFullScreen = !this.isFullScreen;
      if (this.isFullScreen) {
        this.screenTxt = "全屏预览";
        this.OpenFullScreenFn();
        return;
      }

      this.screenTxt = "退出全屏";
      this.ExitFullscreenFn();
    },
    // 打开全屏
    OpenFullScreenFn() {
      let docElm = document.documentElement;
      //W3C
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      }
      //FireFox
      else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      }
      //Chrome等
      else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      }
      //IE11
      else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
      this.isFullScreen = false;
    },
    // 退出全屏
    ExitFullscreenFn() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.isFullScreen = true;
    },
    // mobile-关闭
    CloseReadModeFn(num) {
      if (num === 0) {
        this.readMode = true;
      } else {
        this.readMode = false;
      }
      this.isshowReadmode = false;
      this.isshowToolbar = false;
      this.isshowTurnPage = false;
      this.isshowBreadcrumb = false;
    },
    // 打开已购章节
    OpenPurchased() {
      if (this.searchTitle != "") {
        this.searchTitle = "";
        this.GetPurchasedChapters();
      }

      this.isshowPurchased = !this.isshowPurchased;
      this.isshowReadmode = false;

      // 打开章节 同一页的节高亮
      if (this.isshowPurchased) {
        this.GetLight();
      }
      // mobile 关闭上一节-下一节的显示
      this.isshowTurnPage = false;
    },
    // 高亮
    GetLight() {
      // 当是移动端 or 目录列表不显示时  不执行
      if (!this.isshowPurchased) return;
      this.ForInitialFn(this.catalogList);

      if (
        this.readingPage === 1 ||
        this.readingPage == this.infoObj.pageCount
      ) {
        let nextNum = this.purchasedArr[this.CurrentChapter - 1].next,
          previousNum = this.purchasedArr[this.CurrentChapter - 1].previous;
        if (nextNum === 0 && previousNum === 0) return;
        this.LightFn();
      }
    },
    // 高亮
    LightFn(index, ind) {
      let nextNum = this.purchasedArr[this.CurrentChapter - 1].next,
        previousNum = this.purchasedArr[this.CurrentChapter - 1].previous;

      let key =
        this.infoObj.chapterIndex != null
          ? this.infoObj.chapterIndex
          : this.infoObj.subChapterIndex;

      if (nextNum > 0 && this.readingPage == this.infoObj.pageCount) {
        for (let i = key; i <= key + nextNum; i++) {
          if (this.infoObj.chapterIndex == null) {
            this.$set(this.catalogList[i], "light", true);
          } else {
            this.$set(
              this.catalogList[this.infoObj.chapterIndex].children[i],
              "light",
              true
            );
          }
        }
      }
      if (previousNum > 0 && this.readingPage == 1) {
        for (let j = key; j >= key - previousNum; j--) {
          if (this.infoObj.chapterIndex == null) {
            this.$set(this.catalogList[j], "light", true);
          } else {
            if (j == -1) return;
            this.$set(
              this.catalogList[this.infoObj.chapterIndex].children[j],
              "light",
              true
            );
          }
        }
      }
    },
    // 循环已购目录 判断是已购的第几节
    ForInitialFn(items) {
      items.forEach(item => {
        if (item.light) {
          item.light = false;
          this.$set(item, "light", false);
        }
        if (item.children) {
          this.ForInitialFn(item.children);
        }
      });
    },
    // 返回
    BookReadReturn() {
      this.$router.go(-1);
    },
    // 缩小
    ReducePage() {
      if (this.scaleNamIndex == 0) return;
      this.scaleNamIndex -= 1;
      this.ZoomFn();
    },
    // 放大
    EnlargePage() {
      if (this.scaleNamIndex == 4) return;
      this.scaleNamIndex += 1;
      this.ZoomFn();
    },
    // 放大缩小后需执行的函数
    ZoomFn() {
      let screenWid = document.body.clientWidth;
      let scaleNum = this.scaleNamArr[this.scaleNamIndex] / 100;
      this.$refs.myContent.firstElementChild.style.transform =
        "scale(" + scaleNum + ")";
      let num = this.$refs.myContent.firstElementChild.offsetWidth * scaleNum;
      if (screenWid < num) {
        this.isscale = false;
      } else {
        this.isscale = true;
      }
      if (this.scaleNamIndex == 1) {
        this.$refs.myContent.style.width = "100%";
      } else {
        this.$refs.myContent.style.width = num + "px";
      }
    },
    // 关闭引导提示
    closeGuideTip() {
      this.showGuideTip = false;
      localStorage.setItem("isFirstIntoK", 11);
    }
  },
  components: {
    PurchasedChapters
  }
};
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px) {
  #map_img img {
    width: 100%;
  }

  .loadingWrap,
  .wrapper {
    width: 100%;
    height: 100%;
  }

  .BookRead {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
  }

  /* 面包屑 */
  .BreadcrumbWrap {
    height: 0.88rem;
    padding: 0 0.25rem;
    justify-content: space-between;
  }

  .userWrap img {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
  }

  .titleReturn {
    width: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .titleReturn .return {
    width: 0.4rem;
    height: 0.4rem;
    background: url(../../assets/img/bookRead_return.svg) no-repeat;
    background-size: 100% 100%;
  }

  .titleReturn h3 {
    width: calc(100% - 0.65rem);
    font-size: 0.24rem;
    color: #ffffff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* 页码+标题 */
  .pageTitle {
    width: 100%;
    display: flex;
    align-items: center;
    height: 0.6rem;
    padding: 0 0.25rem;
    background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
  }

  .pageTitle p:first-child {
    padding: 0 0.1rem;
    line-height: 0.4rem;
    margin-right: 0.2rem;
    background: #f6f6f6;
    border-radius: 0.03rem;
    font-size: 0.24rem;
    color: #b3b3b3;
  }

  .pageTitle p:last-child {
    font-size: 0.24rem;
    color: #b6b6b6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .imgWrap {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .imgWrap img {
    width: 100%;
    height: auto;
    position: absolute;
  }

  /* 工具栏-展开 */
  .toolbarOpen {
    height: 1.2rem;
    justify-content: space-around;
    padding: 0 0.6rem;
  }

  /* 已购章节 */
  .buyChapter,
  .ReadingMode .ReadText {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .buyChapter span,
  .ReadingMode .ReadText span {
    margin-top: 4px;
    font-size: 0.22rem;
    color: #8c8c8c;
  }

  /* 阅读模式 */
  .ReadingMode .mode {
    width: 3.88rem;
    padding: 0.24rem;
    background: #353535;
    border-radius: 0.18rem;
    position: absolute;
    top: -1.4rem;
    right: 0.3rem;
  }

  .ReadingMode .mode span:first-child {
    margin-right: 0.25rem;
  }

  .ReadingMode .ReadText img {
    width: 0.4rem;
    height: 0.4rem;
  }

  .ReadingMode .mode span {
    display: inline-block;
    width: 1.52rem;
    line-height: 0.62rem;
    border: 2px solid hsla(0, 0%, 100%, 0.9);
    border-radius: 0.08rem;
    font-size: 12px;
    text-align: center;
    color: hsla(0, 0%, 100%, 0.9);
    letter-spacing: 0;
  }

  /* 进度 */
  .TurnPage_mobile {
    width: 100%;
    height: 1rem;
    padding: 0 0.4rem;
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.9);
    position: absolute;
    bottom: 1.2rem;
    left: 0;
  }

  .TurnPage_mobile > span {
    font-size: 0.28rem;
  }

  .TurnPage_mobile .block {
    width: 4.56rem;
    margin: 0 0.22rem;
  }

  .TurnPage_mobile .pageLight {
    color: rgba(255, 255, 255, 0.9);
  }

  .TurnPage_mobile .pageDisabled {
    color: rgba(255, 255, 255, 0.5);
  }

  @-webkit-keyframes fadeInUp {
    0% {
      -webkit-transform: translateY(20px);
      transform: translateY(20px);
    }

    100% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
    }
  }

  @keyframes fadeInUp {
    0% {
      -webkit-transform: translateY(20px);
      -ms-transform: translateY(20px);
      transform: translateY(20px);
    }

    100% {
      -webkit-transform: translateY(0);
      -ms-transform: translateY(0);
      transform: translateY(0);
    }
  }

  /* 提示 */
  .tipWrap {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    position: fixed;
    top: 0;
    left: 0;
  }

  .mouseTipBox {
    width: 2.08rem;
    height: 4.42rem;
    margin-bottom: 1.28rem;
    background: url(../../assets/img/slideTip.svg) no-repeat center center;
    background-size: 100% 100%;
  }

  .closeChapterBox {
    width: 1.93rem;
    height: 0.76rem;
    margin-bottom: 0.62rem;
    background: url(../../assets/img/know_img.svg) no-repeat center center;
    background-size: 100% 100%;
  }

  .lockingBox {
    width: 6.32rem;
    height: 3.25rem;
    margin-bottom: 0.29rem;
    background: url(../../assets/img/toolbar_tip.png) no-repeat center center;
    background-size: 100% 100%;
  }
}

@media screen and (min-width: 1442px) {
  .BookRead {
    background: #212121;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
  }

  /* 左边 工具栏 */
  .leftToolBar {
    display: flex;
    align-items: center;
    margin: 45px 10px 20px;
  }

  /* 页码+标题 */
  .pageTitle {
    display: flex;
    align-items: center;
    padding: 6px 4px;
    background: rgba(48, 48, 48, 0.7);
    border-radius: 4px;
    color: #ffffff;
  }

  .pageTitle p:first-child {
    width: 65px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    background: url(../../assets/img/pageBg_icon.svg) no-repeat;
    background-size: 100% 100%;
    margin-right: 5px;
  }

  .pageTitle p:last-child {
    width: 250px;
    font-size: 12px;
    letter-spacing: 0;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    height: 34px;
    color: #ff7b5b;
  }

  .leftToolBar .chapterControl {
    background: rgba(48, 48, 48, 0.7) url(../../assets/img/toolbar_icon.svg)
      no-repeat center center;
    border-radius: 4px;
    width: 46px;
    height: 46px;
    margin-left: 5px;
    cursor: pointer;
  }

  /* 右边工具栏 */
  .rightToolBar {
    position: fixed;
    right: 5%;
    bottom: 30px;
  }

  .rightToolBar .scaleWrap {
    background: rgba(48, 48, 48, 0.7);
    text-align: center;
  }

  .rightToolBar .scaleWrap span,
  .rightToolBar .allScreen,
  .homeBox a,
  .updownBtnWrap span,
  .switch-toolbar {
    width: 46px;
    height: 46px;
    display: block;
    cursor: pointer;
  }

  .homeBox {
    margin-bottom: 1px;
    border-radius: 4px;
    text-align: center;
  }

  .homeBox a {
    text-align: center;
    margin-bottom: 1px;
    background: rgba(48, 48, 48, 0.7);
    color: #fff;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .switch-toolbar {
    margin-bottom: 16px;
  }

  .open-tb {
    background: rgba(48, 48, 48, 0.7) url(../../assets/img/open_icon.svg)
      no-repeat center center;
    border-radius: 4px;
  }

  .packup-tb {
    background: rgba(48, 48, 48, 0.7) url(../../assets/img/packup_icon.svg)
      no-repeat center center;
    border-radius: 0 0 4px 4px;
  }

  /* 上下翻页 */
  .updownBtnWrap {
    font-size: 16px;
    color: #ffffff;
  }

  .updownBtnWrap span {
    line-height: 46px;
    text-align: center;
    margin-bottom: 1px;
    background: rgba(48, 48, 48, 0.7);
  }

  .updownBtnWrap span:first-child {
    border-radius: 4px 4px 0 0;
  }

  .rightToolBar .scaleWrap span:first-child {
    background: url(../../assets/img/reduce_icon.svg) no-repeat center center;
  }

  .rightToolBar .scaleWrap span:nth-child(3) {
    background: url(../../assets/img/add_icon.svg) no-repeat center center;
  }

  .rightToolBar .scaleWrap span:nth-child(2) {
    display: inline;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    cursor: auto;
  }

  .rightToolBar .scaleWrap .ScaleDisabled {
    opacity: 0.3;
    cursor: default;
  }

  .rightToolBar .scaleWrap .ScaleLight {
    cursor: pointer;
  }

  .rightToolBar .scaleWrap .locking {
    background: #44d7b6 url(../../assets/img/locking_icon.svg) no-repeat center
      center;
  }

  .rightToolBar .scaleWrap .fitsize {
    background: #2468f2 url(../../assets/img/Fitsize_icon.svg) no-repeat center
      center;
  }

  .rightToolBar .allScreen {
    border-radius: 4px;
  }

  .FullScreen_open {
    background: rgba(48, 48, 48, 0.7) url(../../assets/img/openall_icon.svg)
      no-repeat center center;
  }

  .FullScreen_exit {
    background: rgba(48, 48, 48, 0.7) url(../../assets/img/exitall_icon.svg)
      no-repeat center center;
  }

  /* 内容 */
  .contWrap {
    height: 100%;
    width: calc(100% - 400px);
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    overflow-y: scroll;
    overflow-x: scroll;
  }

  .smallContSty {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .imgWrap {
    height: 100%;
    width: 100%;
  }

  .transformSty img {
    transform-origin: left top;
  }

  .imgWrap .normalImg {
    max-width: 100%;
    max-height: 100%;
  }

  .courseUp {
    cursor: url(../../assets/img/cursor_prev.png), auto;
  }

  .courseDown {
    cursor: url(../../assets/img/cursor_next.png), auto;
  }

  .imgWrap > .scaleImg {
    height: auto;
    width: 100%;
  }

  /* 已购章节盒子 */
  .chaptersBox {
    width: 400px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .PurchasedWrapper {
    overflow: hidden;
  }

  /* 全部目录 */
  .PurchasedShow {
    height: calc(100% - 111px);
    transition: all 1s ease-in;
    -moz-transition: all 1s ease-in;
    /* Firefox 4 */
    -webkit-transition: all 1s ease-in;
    /* Safari and Chrome */
    -o-transition: all 1s ease-in;
    /* Opera */
  }

  /* 提示 */
  .tipWrap {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
  }

  /* 关闭目录 */
  .closeChapterBox {
    width: 159px;
    margin: 45px 0 0 285px;
  }

  .closeChapterBox p:last-child {
    background-image: linear-gradient(90deg, #4c7efd 0%, #4d65fd 100%);
    border-radius: 4px;
    font-size: 16px;
    color: #ffffff;
    line-height: 46px;
    text-align: center;
    position: relative;
  }

  .closeChapterBox span {
    width: 0px;
    height: 0px;
    border-top: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #4d65fd;
    border-left: 7px solid transparent;
    position: absolute;
    top: -14px;
    left: 50%;
    transform: translateX(-50%);
  }

  .closeChapterBox img {
    position: absolute;
    right: -75px;
    bottom: 0;
  }

  .closeChapterBox p:first-child {
    width: 46px;
    height: 46px;
    margin: 0 auto 15px;
    background: rgba(48, 48, 48, 0.7) url(../../assets/img/toolbar_icon.svg)
      no-repeat center center;
  }

  /* 滚轮提示 */
  .mouseTipBox {
    width: 211px;
    height: 495px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  /* 锁定 */
  .lockingBox {
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 138px;
    right: 5%;
  }

  .lockingBox p:first-child {
    width: 228px;
    line-height: 46px;
    background-image: linear-gradient(90deg, #4c7efd 0%, #4d65fd 100%);
    border-radius: 4px;
    text-align: center;
    font-size: 16px;
    color: #ffffff;
    position: relative;
  }

  .lockingBox span {
    width: 0px;
    height: 0px;
    border-top: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 7px solid #4d65fd;
    position: absolute;
    right: -14px;
    top: 50%;
    transform: translateY(-50%);
  }

  .lockingBox img {
    position: absolute;
    left: -75px;
    bottom: 0;
  }

  .lockingBox p:last-child {
    width: 46px;
    height: 46px;
    margin-left: 15px;
    background: #2468f2 url(../../assets/img/Fitsize_icon.svg) no-repeat center
      center;
  }
}

@media screen and (min-width: 1029px) and (max-width: 1440px) {
  .BookRead {
    background: #212121;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
  }

  /* 左边 工具栏 */
  .leftToolBar {
    display: flex;
    align-items: center;
    margin: 25px 10px 10px;
  }

  /* 页码+标题 */
  .pageTitle {
    display: flex;
    align-items: center;
    padding: 5px 0;
    background: rgba(48, 48, 48, 0.7);
    border-radius: 4px;
  }

  /* .pageTitle p span {
            display: none;
        } */

  .pageTitle p:first-child {
    width: 60px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    background: url(../../assets/img/pageBg_icon.svg) no-repeat;
    background-size: 100% 100%;
    margin-right: 2px;
    color: rgba(255, 255, 255, 0.3);
  }

  .pageTitle p:last-child {
    width: 180px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    letter-spacing: 0;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    height: 34px;
  }

  .leftToolBar .chapterControl {
    background: rgba(48, 48, 48, 0.7) url(../../assets/img/toolbar_icon.svg)
      no-repeat center center;
    border-radius: 4px;
    width: 43px;
    height: 43px;
    margin-left: 4px;
    cursor: pointer;
  }

  /* 右边工具栏 */
  .rightToolBar {
    position: fixed;
    right: 5%;
    bottom: 30px;
  }

  .rightToolBar .scaleWrap,
  .homeBox {
    background: rgba(48, 48, 48, 0.7);
    text-align: center;
  }

  .rightToolBar .scaleWrap span,
  .rightToolBar .allScreen,
  .homeBox a,
  .updownBtnWrap span,
  .switch-toolbar {
    width: 46px;
    height: 46px;
    display: block;
    cursor: pointer;
  }

  .homeBox {
    margin-bottom: 1px;
    border-radius: 4px;
    text-align: center;
  }

  .homeBox a {
    text-align: center;
    margin-bottom: 1px;
    background: rgba(48, 48, 48, 0.7);
    color: #fff;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .switch-toolbar {
    margin-bottom: 16px;
  }

  .open-tb {
    background: rgba(48, 48, 48, 0.7) url(../../assets/img/open_icon.svg)
      no-repeat center center;
    border-radius: 4px;
  }

  .packup-tb {
    background: rgba(48, 48, 48, 0.7) url(../../assets/img/packup_icon.svg)
      no-repeat center center;
    border-radius: 0 0 4px 4px;
  }

  /* 左右翻页 */
  .updownBtnWrap {
    border-radius: 4px;
    font-size: 16px;
    color: #ffffff;
  }

  .updownBtnWrap span {
    line-height: 46px;
    margin-bottom: 1px;
    text-align: center;
    background: rgba(48, 48, 48, 0.7);
  }

  .updownBtnWrap span:first-child {
    border-radius: 4px 4px 0 0;
  }

  .rightToolBar .scaleWrap span:first-child {
    background: url(../../assets/img/reduce_icon.svg) no-repeat center center;
  }

  .rightToolBar .scaleWrap span:nth-child(3) {
    background: url(../../assets/img/add_icon.svg) no-repeat center center;
  }

  .rightToolBar .scaleWrap span:nth-child(2) {
    display: inline;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    cursor: auto;
  }

  .rightToolBar .scaleWrap .ScaleDisabled {
    opacity: 0.3;
    cursor: default;
  }

  .rightToolBar .scaleWrap .ScaleLight {
    cursor: pointer;
  }

  .rightToolBar .scaleWrap .locking {
    background: #44d7b6 url(../../assets/img/locking_icon.svg) no-repeat center
      center;
  }

  .rightToolBar .scaleWrap .fitsize {
    background: #2468f2 url(../../assets/img/Fitsize_icon.svg) no-repeat center
      center;
  }

  .rightToolBar .allScreen {
    border-radius: 4px;
  }

  .FullScreen_open {
    background: rgba(48, 48, 48, 0.7) url(../../assets/img/openall_icon.svg)
      no-repeat center center;
  }

  .FullScreen_exit {
    background: rgba(48, 48, 48, 0.7) url(../../assets/img/exitall_icon.svg)
      no-repeat center center;
  }

  /* 内容 */
  .contWrap {
    height: 100%;
    width: calc(100% - 310px);
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    overflow-y: scroll;
    overflow-x: scroll;
  }

  .smallContSty {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .imgWrap {
    height: 100%;
    width: 100%;
  }

  .transformSty img {
    transform-origin: left top;
  }

  .imgWrap .normalImg {
    max-width: 100%;
    max-height: 100%;
  }

  .imgWrap > .scaleImg {
    height: auto;
    width: 100%;
  }

  /* 已购章节盒子 */
  .chaptersBox {
    width: 310px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .PurchasedWrapper {
    overflow: hidden;
  }

  /* 全部目录 */
  .PurchasedShow {
    height: calc(100% - 90px);
    transition: all 1s ease-in;
    -moz-transition: all 1s ease-in;
    /* Firefox 4 */
    -webkit-transition: all 1s ease-in;
    /* Safari and Chrome */
    -o-transition: all 1s ease-in;
    /* Opera */
  }

  /* 提示 */
  .tipWrap {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
  }

  /* 关闭目录 */
  .closeChapterBox {
    width: 159px;
    margin: 25px 0 0 217px;
  }

  .closeChapterBox p:last-child {
    background-image: linear-gradient(90deg, #4c7efd 0%, #4d65fd 100%);
    border-radius: 4px;
    font-size: 14px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    position: relative;
  }

  .closeChapterBox span {
    width: 0px;
    height: 0px;
    border-top: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #4d65fd;
    border-left: 7px solid transparent;
    position: absolute;
    top: -14px;
    left: 50%;
    transform: translateX(-50%);
  }

  .closeChapterBox img {
    position: absolute;
    right: -75px;
    bottom: -1px;
  }

  .closeChapterBox p:first-child {
    width: 43px;
    height: 43px;
    margin: 0 auto 15px;
    background: rgba(48, 48, 48, 0.7) url(../../assets/img/toolbar_icon.svg)
      no-repeat center center;
  }

  /* 滚轮提示 */
  .mouseTipBox {
    width: 211px;
    height: 495px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  /* 锁定 */
  .lockingBox {
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 138px;
    right: 5%;
  }

  .lockingBox p:first-child {
    width: 215px;
    line-height: 40px;
    background-image: linear-gradient(90deg, #4c7efd 0%, #4d65fd 100%);
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    position: relative;
  }

  .lockingBox span {
    width: 0px;
    height: 0px;
    border-top: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 7px solid #4d65fd;
    position: absolute;
    right: -14px;
    top: 50%;
    transform: translateY(-50%);
  }

  .lockingBox img {
    position: absolute;
    left: -75px;
    bottom: 0;
  }

  .lockingBox p:last-child {
    width: 46px;
    height: 46px;
    margin-left: 15px;
    background: #2468f2 url(../../assets/img/Fitsize_icon.svg) no-repeat center
      center;
  }
}

/* 面包屑 */
.BreadcrumbWrap {
  width: 100%;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.9);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 22;
}

.Breadcrumb a {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
}

.Breadcrumb a span {
  color: #999999;
}

.Breadcrumb > span {
  width: calc(100% - 364px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
}

/* 工具栏-展开 */
.toolbarOpen {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.9);
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
}

.PurchasedHide {
  height: 0px;
  transition: all 1s ease-out;
  -moz-transition: all 1s ease-out;
  /* Firefox 4 */
  -webkit-transition: all 1s ease-out;
  /* Safari and Chrome */
  -o-transition: all 1s ease-out;
  /* Opera */
}

/* 阅读模式 */
.ReadingMode .mode .modeLight,
.scaleMode .mode .modeLight {
  border: 2px solid #2468f2;
  color: #2468f2;
}
</style>



// WEBPACK FOOTER //
// src/pages/BookDetails/BookRead.vue